import { STEPPER_GLOBAL_OPTIONS, StepperOrientation } from '@angular/cdk/stepper';
import { Component, inject, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { map, Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SppdashboardService } from '../../view/dashboard/sppdashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HelpdeskService } from '../admin/helpdesk/helpdesk.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserDataModalComponent } from '../../component/user-data-modal/user-data-modal.component';
import { differenceInDays } from 'date-fns'
import { urlValidator } from '../../utils/urlvalidator';
import { environment } from '../../../../src/environments/env';
import { LiveComponent } from '../live/live.component';
import { Mtm } from 'src/app/services/mtm';
import { LoaderService } from '@pearsonvue/topaz-angular-ui';
import { linkedInUrlValidator } from 'src/app/utils/linkedin-urlvalidator';
import { activeStatusesList, namewithSpace, pronounsList, salutationList, solutionAreasList, topTechnicalAreasList } from 'src/app/utils/constants';
import { Router } from '@angular/router';
import { YoodliRegConfirmationComponent } from 'src/app/component/yoodli-reg-confirmation/yoodli-reg-confirmation.component';
import { AppendixAComponent } from 'src/app/view/appendix-a/appendix-a.component';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrl: './vouchers.component.scss',
  standalone: false,
  providers: [
    DatePipe,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false, showError: true },
    }
  ]
})


export class VouchersComponent implements OnInit {
  public country: any;
  public mctSubscriptionEndDate: any;
  public status: any = '';
  public formSubmitted: boolean = false;
  public isCheckboxSelected = false;
  public show: boolean | null = null;
  public dialogConfig: any = {};
  public subject: any;
  public daysDifference: any;
  public emailp: any;
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;

  public personalInfoForm: any;
  public renewalDetailsForm: any;
  public confirmationForm: any;
  public stepperOrientation!: Observable<StepperOrientation>;
  public snackbar = inject(MatSnackBar);
  disableSubmit: boolean = false;
  renewalRejectReasons: any = [];
  pronounsList = pronounsList;
  salutationList = salutationList;
  solutionAreasList = solutionAreasList;
  activeStatusesList = activeStatusesList;
  topTechnicalAreasList = topTechnicalAreasList;
  timezoneList: any[] = [];
  countryList: any[] = [];
  languageList: any[] = [];
  showYoodliConfirmation = false;
  timelinedate: any;
  rtimeline: any;
  loggedInUser: any;

  constructor(
    private readonly _live: LiveComponent,
    private readonly _fb: FormBuilder,
    private readonly sppdashboardService: SppdashboardService,
    private readonly helpService: HelpdeskService,
    private readonly dialogModel: MatDialog,
    private readonly datePipe: DatePipe,
    private readonly _mtm: Mtm,
    private readonly breakpointObserver: BreakpointObserver,
    private loaderService: LoaderService,
    private router: Router,
  ) {

    this.stepperOrientation = this.breakpointObserver
      .observe('(min-width: 600px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));

  }


  ngOnInit() {

    this.dialogConfig = {
      type: 'delete',
      forComponent: 'Announcement',
      value: '',
      headerTitle: ''
    };

    this.initializeFormFields();
    this.loggedInUser = this._live.currentLinkValue as any;
    if (this.loggedInUser === 'default') {
      this.router.navigate(['/home']);
      return;
    }

    this.emailp = this.loggedInUser?.email;
    this.status = this.loggedInUser?.status;

    this.mctSubscriptionEndDate = this.loggedInUser?.mctSubscriptionEndDate || '';
    this.country = this.loggedInUser?.country || '';

    // dropdown lists are needed whenever the renewal form can be shown, not only for ACTIVE_MCT
    
    if(this.status === 'ACTIVE_MCT'){
      this.getTimezonesByCountry();
      this.getLanguageList();
      this.getCountryList();
    }
 
    this.getRewalUserData();


    //  OPEN ----------> on OPEN it dosen't visit the RENEWAL-FORM

    // if (this.status === 'OPEN') {
    //   this._auth.currentMessage.subscribe((res: any) => {
    //     this.personalInfoForm.patchValue({
    //       salutation: res.salutation,
    //       pronouns: res.pronouns,
    //       firstname: res.firstname,
    //       lastname: res.lastname,
    //       email: res.email,
    //     });

    //     this.renewalDetailsForm.patchValue({
    //       primarySupportRegions: Array.isArray(res.country) ? res.country : res.country ? [res.country] : [],
    //       timezone: res.timezone || res.timeZone,
    //       renewalLanguage: Array.isArray(res.language) ? res.language : res.language ? [res.language] : [],
    //       transScriptUrl: res.transScriptUrl || '',
    //       solutionAreas: Array.isArray(res.solutionAreas)
    //         ? res.solutionAreas
    //         : res.solutionAreas ? [res.solutionAreas] : [],
    //       activeStatuses: Array.isArray(res.activeStatuses)
    //         ? res.activeStatuses
    //         : res.activeStatuses ? [res.activeStatuses] : [],
    //       topTechnicalAreas: Array.isArray(res.topTechnicalAreas)
    //         ? res.topTechnicalAreas
    //         : res.topTechnicalAreas ? [res.topTechnicalAreas] : [],
    //       awardsRecognitions: res.awardsRecognitions || '',
    //       shortBiography: res.shortBiography || ''
    //     });

    //     this.confirmationForm.patchValue({
    //       mctDirectoryOptOut: res.mctDirectoryOptOut ?? false
    //     });
    //   })
    // }
  }



  initializeFormFields() {
    this.personalInfoForm = this._fb.group({
      salutation: ['', [Validators.required]],
      pronouns: ['', [Validators.required]],
      firstname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      email: ['', [Validators.required]],
      country: ['', [Validators.required]],
      timezone: ['', [Validators.required]],
    });

    this.renewalDetailsForm = this._fb.group({
      primarySupportRegions: [[]],
      renewalLanguage: [[]],
      transScriptUrl: ['', [Validators.required, urlValidator]],
      solutionAreas: [[], [Validators.required]],
      activeStatuses: [[]],
      topTechnicalAreas: [[], [Validators.required]],
      microsoftTechnologyCoursesPerYear: ['', [Validators.required, Validators.pattern(/^\d+$/), Validators.max(999)]],
      tspDeliveryPercentage: ['', [Validators.required]],
      website: ['', [urlValidator]],
      linkedInUrl: ['', [linkedInUrlValidator]],
      awardsRecognitions: [''],
      shortBiography: [''],
    });

    this.confirmationForm = this._fb.group({
      mctAgreement: [{ value: '', disabled: true }, Validators.required],
      mctDirectoryOptOut: [false],
    });
  }


  getRewalUserData() {
    this._mtm.getRenewalUser().subscribe((response: any) => {
      if (response?.success === true) {
        if (this.status === 'RENEWAL_APPROVE') {
          this.personalInfoForm.disable();
          this.renewalDetailsForm.disable();
          this.confirmationForm.disable();
          this.isCheckboxSelected = true;
        } else if (this.status === 'RENEWAL_REJECT') {
          this.show = false;
          this.getRejectionReasons();
        } else {
          this.personalInfoForm.enable();
          this.renewalDetailsForm.enable();
          this.confirmationForm.enable();
          this.personalInfoForm.get('email')?.disable();
          this.confirmationForm.get('mctAgreement')?.disable();
        }

        this.personalInfoForm.patchValue({
          salutation: response?.data?.salutation,
          pronouns: response?.data?.pronouns,
          firstname: response?.data?.firstname,
          lastname: response?.data?.lastname,
          email: response?.data?.email,
          country: response?.data?.country,
          timezone: response?.data?.timezone,
        });

        this.renewalDetailsForm.patchValue({
          primarySupportRegions: Array.isArray(response?.data?.primarySupportRegions)
            ? response?.data?.primarySupportRegions
            : response?.data?.primarySupportRegions ? [response?.data?.primarySupportRegions] : [],
          renewalLanguage: Array.isArray(response?.data?.renewalLanguage)
            ? response?.data?.renewalLanguage
            : response?.data?.renewalLanguage ? [response?.data?.renewalLanguage] : [],
          transScriptUrl: response?.data?.transScriptUrl,
          solutionAreas: Array.isArray(response?.data?.solutionAreas)
            ? response?.data?.solutionAreas
            : response?.data?.solutionAreas ? [response?.data?.solutionAreas] : [],
          activeStatuses: Array.isArray(response?.data?.activeStatuses)
            ? response?.data?.activeStatuses
            : response?.data?.activeStatuses ? [response?.data?.activeStatuses] : [],
          topTechnicalAreas: Array.isArray(response?.data?.topTechnicalAreas)
            ? response?.data?.topTechnicalAreas
            : response?.data?.topTechnicalAreas ? [response?.data?.topTechnicalAreas] : [],
          microsoftTechnologyCoursesPerYear: response?.data?.microsoftTechnologyCoursesPerYear ?? '',
          tspDeliveryPercentage: response?.data?.tspDeliveryPercentage ?? '',
          website: response?.data?.website,
          linkedInUrl: response?.data?.linkedInUrl,
          awardsRecognitions: response?.data?.awardsRecognitions,
          shortBiography: response?.data?.shortBiography,
        });

        // this.confirmationForm.patchValue({
        //   mctAgreement: response?.data?.mctAgreement,
        //   mctDirectoryOptOut: response?.data?.mctDirectoryOptOut ?? false,
        // })

        if (sessionStorage.getItem('timeline') && sessionStorage.getItem('remindertimeline')) {

          this.rtimeline = sessionStorage.getItem('remindertimeline') ? Number(sessionStorage.getItem('remindertimeline')) : '';

          const currentDate = new Date();
          const endDate = new Date(this.mctSubscriptionEndDate ? this.mctSubscriptionEndDate : new Date());
          const reminderDate = new Date(endDate);
          reminderDate.setDate(reminderDate.getDate() - this.rtimeline);
          this.daysDifference = differenceInDays(currentDate, reminderDate);

          if (this.status == 'RENEWAL_REJECT' || this.status == 'RENEWAL_EXAM') {
            this.show = false;
          } else if (currentDate >= reminderDate && this.daysDifference <= this.rtimeline) {
            this.show = true;
          } else if (this.status == 'ACTIVE_MCT' || this.status == 'RENEWAL_APPROVE') {
            this.show = false;
            // NEED to verify this ---- after updating te status
            // response.status = this.status;
            response.message = `Your MCT status is active through ${this.datePipe.transform(this.mctSubscriptionEndDate, 'MMMM d, y')}. You may renew your subscription up to 90 days prior to this date.`
            this.dialogConfig.value = response;
            this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
          } else {
            this.show = true;
          }

          if (this.daysDifference > 0 && this.status != "EXPIRED") {

            if (this.daysDifference == 60 || this.daysDifference == 30 || this.daysDifference == 15 || this.daysDifference == 1) {
              this.sppdashboardService.getTemplateUser(4).subscribe((res: any) => {
                this.subject = res.subject;
                if (this.emailp != undefined && this.subject != undefined) {
                  const tempObject = {
                    "recipientEmail": this.emailp,
                    "subject": this.subject,
                    "templateName": 'MCTExpired',
                    "language": "en",
                    "customContext": "{}"
                  }

                  this.helpService.sendEmailUser(tempObject).subscribe((res: any) => {
                    if (!res.success) {
                      this.snackbar.open(res.errors, '', { verticalPosition: 'top', horizontalPosition: 'center' });
                    }
                  }, (error: any) => {
                    const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
                    errMsg?.map((msg: string) => {
                      this.snackbar.open(msg, '', { verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['warning'] });
                    });
                  })
                }
              })
            }
          }
        }

        if (this.status === 'RENEWAL_APPROVE' || this.status === 'RENEWAL_REJECT') {
          this.isCheckboxSelected = true;
        }
      }
    });
  }

  // allowOnlyAlphabets(event: KeyboardEvent): boolean {
  //   const charCode = event.key.charCodeAt(0);
  //   // Allow A-Z, a-z and Space
  //   if (
  //     (charCode >= 65 && charCode <= 90) ||
  //     (charCode >= 97 && charCode <= 122) ||
  //     charCode === 32
  //   ) {
  //     return true;
  //   }
  //   event.preventDefault();
  //   return false;
  // }

  submit() {
    this.formSubmitted = true;
    this.personalInfoForm.markAllAsTouched();
    this.renewalDetailsForm.markAllAsTouched();
    this.confirmationForm.markAllAsTouched();
    if (this.formSubmitted && this.personalInfoForm.valid && this.renewalDetailsForm.valid && this.confirmationForm.valid && this.isCheckboxSelected) {
      this.disableSubmit = true;

      const personalInfo = this.personalInfoForm.getRawValue();
      const renewalDetails = this.renewalDetailsForm.getRawValue();
      const confirmation = this.confirmationForm.getRawValue();
      const payload = {
        ...personalInfo,
        ...renewalDetails,
        ...confirmation,
      }

      // console.log("##Payload", payload);

      this.loaderService.showLoader('Submitting application...');
      this.sppdashboardService.renewalSubmit(payload).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.loaderService.hideLoader();
            this.formSubmitted = false;
            this.disableSubmit = false;
            this._live.changeLink(res?.data);
            if (res?.data?.status === 'RENEWAL_APPROVE') {
              this.renewalRejectReasons = [];
              res.message = `
                Thank you for completing your renewal application. Our records indicate that you have met the 6-session renewal requirement.
                <br/> <br/>
                Please proceed to completing your payment and renewing your subscription and benefits.`
              res.title = "🎉 Congratulations - You've met the 6-session renewal requirement!"
              this.dialogConfig.value = res;
              this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
            } else {
              this.loaderService.hideLoader();
              this.show = false;
              this.status = res?.data?.status;
              this.renewalRejectReasons = res?.data?.reasons ?? [];
              res.title = 'Sorry - You have not met the 6-session renewal requirement 😔';
              res.message = `Thank you for completing your renewal application. Our records indicate that you have not met the 6-session renewal requirement.
                <br/><br/>
                Fortunately, you are eligible for our alternative renewal pathway. Don't let your status lapse! To learn more, 
                please proceed to the next page.`;
              this.dialogConfig.value = res;
              this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
            }
          } else {
            this.loaderService.hideLoader();
            this.disableSubmit = false;
            this.dialogConfig.value = {
              title: 'Unable to Verify Renewal Eligibility',
              message: ` 
                We were unable to find your renewal eligibility because the email address or MCT information provided does not match our records.
                please contact the support team.<br/>
                <span class="support-contact">For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>. - we’re here to help!</span>
              `
            };
            this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
          }
        },
        error: () => {
          this.loaderService.hideLoader();
          this.disableSubmit = false;
        }
      });
    }

  }

  onClickTesturl() {
    const url = this.renewalDetailsForm.get('transScriptUrl').value;
    if (this.isSafeUrl(url)) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      console.warn('Blocked untrusted redirect target:', url);
      // optionally show a user-facing error/toast
    }
  }


  private isSafeUrl(url: string): boolean {
    try {
      // 1. If it doesn't start with a protocol, native URL constructor might fail.
      // Ensure we are working with an absolute URL.
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return false;
      }

      const parsedUrl = new URL(url);

      // 2. Strict Protocol Whitelist (Blocks javascript: and data: protocols)
      const allowedProtocols = ['https:', 'http:'];
      if (!allowedProtocols.includes(parsedUrl.protocol)) {
        return false;
      }

      // 3. Since Microsoft Learn transcripts belong to any domain, we allow all hostnames
      // but ensure the hostname is structurally present and valid.
      return parsedUrl.hostname.length > 0;
    } catch (e) {
      // If the URL constructor throws an error, the URL is malicious or malformed.
      return false;
    }
  }
  getTranscript() {
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/How_to_access_your_Learn_Transcript/download`;
    window.open(pdfUrl, '_blank');
  }

  openAppendixA() {
    this.dialogModel.open(AppendixAComponent, { data: {} });
  }

  openYoodliConfirmation(): void {
    this.showYoodliConfirmation = true;
    const dialogRef = this.dialogModel.open(YoodliRegConfirmationComponent, { data: {} });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.confirmYoodliRegistration();
      } else {
        this.closeYoodliConfirmation();
      }
    });
  }

  closeYoodliConfirmation(): void {
    this.showYoodliConfirmation = false;
  }

  confirmYoodliRegistration(): void {
    const payload = {
      email: this.emailp,
    };
    this._mtm.yoodlipheseoneRegister(payload).subscribe({
      next: (res: any) => {
        this.status = "RENEWAL_EXAM";
        const userData = this._live.currentLinkValue as any;
        const updatedUserData = {
          ...userData,
          status: 'RENEWAL_EXAM'
        };
        this._live.changeLink(updatedUserData);
      }
    });
    this.closeYoodliConfirmation();
  }

  agrementDoc = () => {
    if (!this.disableSubmit) {
      this.confirmationForm.get('mctAgreement')?.enable();
    }
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/mct_agreement/download`;
    window.open(pdfUrl, '_blank');
  }

  getRejectionReasons() {
    this._mtm.getRejectionReasons().subscribe((res: any) => {
      if (res.success) {
        this.renewalRejectReasons = res?.data?.rejectionReasons ?? [];
      } else {
        this.renewalRejectReasons = [];
      }
    });
  }


  getLanguageList() {
    this.sppdashboardService.getLanguageList().subscribe({
      next: (response: any) => {
        this.languageList = Array.isArray(response) ? response : [];
      },
      error: (error: any) => {
        this.languageList = [];
        console.error('Error fetching Language List', error);
      }
    });
  }

  getCountryList() {
    this.sppdashboardService.getCountryList().subscribe({
      next: (response: any) => {
        this.countryList = Array.isArray(response) ? response : [];
      },
      error: (error: any) => {
        this.countryList = [];
        console.error('Error fetching Country List', error);
      }
    });
  }


  getTimezonesByCountry() {
    this.sppdashboardService.getTimeZonesByCountryName(this.country).subscribe({
      next: (timezoneResponse: any) => {
        this.timezoneList = timezoneResponse?.success && Array.isArray(timezoneResponse.data)
          ? timezoneResponse.data
          : [];
      },
      error: (error: any) => {
        this.timezoneList = [];
        console.error('Error fetching Timezone List', error);
      }
    });
  }

  onCountryChange(event: any): void {
    this.country = event.value;
    this.personalInfoForm.get('timezone')?.setValue('');
    this.getTimezonesByCountry();
  }


}
